/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerErrors
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'detectedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'calculatedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'colorGradation'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'heightMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'widthMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum;
}

export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum];


